export default __webpack_public_path__ + "static/media/ceremony.e5fb3c64.png";